<p-dialog header="Ký điện tử không thành công" [(visible)]="pluginNotFound" [style]="{width: '580px'}"
  [resizable]="false">
  <div class="p-grid">
    <div class="p-col-2 p-text-center">
      <img src="/assets/images/usb-not-connected-icon.png" alt="">
    </div>
    <div class="p-col-10">
      <p><b>Hãy kiểm tra các trường hợp dưới đây để khắc phục vấn đề của bạn</b></p>
      <p><b>1.</b> Bạn chưa cài đặt phần mềm ký điện tử My Invoice hoặc bản cài của bạn cần cập nhật</p>
      <p class="p-pl-4">Hãy cài đặt phần mềm ký điện tử My Invoice để tiếp tục.</p>
      <p class="p-pl-4"><a target="_blank" rel="noopener noreferrer" href="assets/tools/MSSigningToolSetup.zip"><i
            class="pi pi-download"></i> Tải phần mềm ký</a></p>
      <p><b>2.</b> Bạn đã cài đặt công cụ <b>Ký số điện tử My Invoice</b></p>
      <p class="p-pl-4">Hãy mở công cụ <b>Ký số điện tử My Invoice</b> trước khi ký điện tử</p>

      <p><b>Liên hệ hỗ trợ:</b> 1900.989.920 - 0941.996.979 - 0962.626.700 - 0936.878.611</p>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised" (onClick)="pluginNotFound=false"></p-button>
  </p-footer>
</p-dialog>
<p-dialog header="Chọn hình thức ký" [(visible)]="display" [style]="{width: '550px'}" styleClass="no-scroll"
  [resizable]="false">
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12">
      <p-dropdown id="type" [options]="signingTypes" (onChange)=typeSelect($event)></p-dropdown>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Xác nhận'|translate }}" styleClass="p-button-raised" (onClick)="submit()"></p-button>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised p-button-text p-button-plain"
      (onClick)="display=false"></p-button>
  </p-footer>
</p-dialog>
<p-dialog header="Chọn CTS" [(visible)]="display2" [style]="{width: '550px'}" styleClass="no-scroll"
  [resizable]="false">
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12">
      <label for="type2">{{ 'CTS'|translate }}<span class="required">*</span></label>
      <p-dropdown id="type2" [(ngModel)]="selectedCTS" optionLabel="label" [options]="items"
        (onChange)="onCTSChange($event.value)"></p-dropdown>
    </div>
    <div class="p-field p-col-12" *ngIf="displayPinCode">
      <form [formGroup]="form">
        <label for="pinCode">{{ 'Mã PIN'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="pinCode" formControlName="pinCode">
      </form>

    </div>
  </div>

  <p-footer>
    <p-button label="Ký xác thực" styleClass="p-button-raised" (onClick)=submit2()></p-button>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised p-button-text p-button-plain"
      (onClick)="  display2=false"></p-button>
  </p-footer>
</p-dialog>
<p-dialog [(visible)]="display3" [closable]="false"
  [style]="{width: '413px', height:'230px', boxShadow:' 8px rgba(0, 0, 0, 0.2)', borderRadius:'10px'}"
  styleClass="no-scroll" [resizable]="false">
  <!--  <div *ngIf="selected!=='IntrustRemoteSigning'" [style]="{textAlign:'center'}">-->
  <!--    <div class="spinner"></div>-->
  <!--    <div class="message">-->
  <!--      <span >Đã gửi yêu cầu ký đến ứng dụng Mysign.</span>-->
  <!--      <br>-->
  <!--      Vui lòng truy cập ứng dụng để thực hiện ký xác thực-->
  <!--    </div>-->
  <!--    <div class="countdown" id="countdown">-->
  <!--      <b>{{ minutes < 10 ? '0' + minutes : minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }}</b>-->
  <!--    </div>-->
  <!--    <div  class="note">-->
  <!--      Xem hướng dẫn ký trên Mysign tại-->
  <!--      <a href="https://www.youtube.com/watch?v=2zGfwoLBNHc" target="_blank">đây</a>-->
  <!--    </div>-->
  <!--  </div>-->
  <div *ngIf="selected==='IntrustRemoteSigning'" [style]="{textAlign:'center'}">
    <p-progressSpinner styleClass="w-8rem h-8rem" strokeWidth="8" animationDuration=".5s"></p-progressSpinner>
    <div class="message">
      <span>Đang ký xác thực trên Intrust...</span>
    </div>
  </div>
</p-dialog>
<p-dialog [(visible)]="display4" [modal]="true" [closable]="false" [style]="{width: '500px', height:'200px'}"
  styleClass="no-scroll" [resizable]="false">
  <div [style]="{textAlign:'center'}">
    <p-progressSpinner styleClass="w-8rem h-8rem" strokeWidth="8" animationDuration=".5s"></p-progressSpinner>
    <div class="message2">
      <b>Đang ký xác thực...</b>
    </div>
  </div>
</p-dialog>
